import { CalendarOutlined, DollarOutlined, TrophyOutlined, UserOutlined } from "@ant-design/icons";

export const getQuoteData = [
    {
        title: 'Beauty consultants',
        subtitle: 'Beautician (Business)',
        details: [
            {
                icon: <UserOutlined />,
                title: 'Jhon Watson',
            },
            {
                icon: <CalendarOutlined />,
                title: 'Dec 12, 2024',
            },
            {
                icon: <DollarOutlined />,
                title: '$700 month',
            },
            {
                icon: <TrophyOutlined />,
                title: '3+ Years',
            },
        ]
    },
    {
        title: 'Flooring specialist',
        subtitle: 'Floor Store (Business)',
        details: [
            {
                icon: <UserOutlined />,
                title: 'Jhon Watson',
            },
            {
                icon: <CalendarOutlined />,
                title: 'Dec 12, 2024',
            },
            {
                icon: <DollarOutlined />,
                title: '$700 month',
            },
            {
                icon: <TrophyOutlined />,
                title: '3+ Years',
            },
        ]
    },
    {
        title: 'Heating and cooling services',
        subtitle: 'Heatup Best (Business)',
        details: [
            {
                icon: <UserOutlined />,
                title: 'Jhon Watson',
            },
            {
                icon: <CalendarOutlined />,
                title: 'Dec 12, 2024',
            },
            {
                icon: <DollarOutlined />,
                title: '$700 month',
            },
            {
                icon: <TrophyOutlined />,
                title: '3+ Years',
            },
        ]
    },
]